// Each track = one connected calendar's busy blocks (three widths per row).
const TRACKS = [
  { name: "Work · Google", segs: [{ flex: 2, on: "var(--lp-lilac)" }, { flex: 1, on: false }, { flex: 1.5, on: "var(--lp-lilac)" }] },
  { name: "Team · Microsoft", segs: [{ flex: 1, on: false }, { flex: 2.5, on: "var(--lp-sky)" }, { flex: 1, on: false }] },
  { name: "Personal · Google", segs: [{ flex: 1.5, on: "var(--lp-blush)" }, { flex: 1, on: false }, { flex: 2, on: "var(--lp-blush)" }] },
  { name: "Bookable", segs: [{ flex: 1, on: "var(--lp-sage)" }, { flex: 1, on: "faint" }, { flex: 1, on: "var(--lp-sage)" }] },
];

const CHIPS = [
  { label: "Live sync", mobileLabel: "Live sync" },
  { label: "Auto-guarded conflicts", mobileLabel: "Conflict guard" },
  { label: "Time zones handled", mobileLabel: "Time zones" },
];

export function LandingIntelligence() {
  return (
    <section id="intelligence" style={{ padding: "clamp(20px, 3vw, 40px) 0" }}>
      <div className="lp-container">
        <div
          className="lp-intel-card"
          data-reveal
          style={{
            position: "relative",
            overflow: "hidden",
            background: "var(--lp-plum-900)",
            color: "var(--lp-cream)",
            borderRadius: "var(--lp-radius-lg)",
            padding: "clamp(32px, 4vw, 56px)",
          }}
        >
          {/* Ambient drifting glow — the one dark section gets a slow living gradient. */}
          <div
            className="lp-anim-drift"
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: "-40% -20% auto auto",
              width: "70%",
              height: "180%",
              background: "radial-gradient(closest-side, rgba(184,166,221,.28), transparent 70%)",
              pointerEvents: "none",
            }}
          />
          <div
            className="stack-md"
            style={{
              position: "relative",
              zIndex: 1,
              display: "grid",
              gridTemplateColumns: "1.05fr .95fr",
              gap: 44,
              alignItems: "center",
            }}
          >
            <div>
              <span style={{ fontFamily: "var(--lp-mono)", fontSize: 11, letterSpacing: ".16em", textTransform: "uppercase", color: "rgba(255,253,250,.5)" }}>
                Quiet intelligence
              </span>
              <h2 className="lp-h1" style={{ marginTop: 14, color: "var(--lp-cream)" }}>
                Calmer because <em style={{ color: "var(--lp-lavender)" }}>it's smarter underneath.</em>
              </h2>
              <p className="lp-intel-lede" style={{ fontSize: 17, color: "rgba(255,253,250,.72)", maxWidth: "44ch", margin: "20px 0 0" }}>
                <span className="lp-intel-lede-desktop">
                  BunnyCal watches every connected calendar - Google and Microsoft - and keeps your
                  booking page truthful in real time.
                </span>
                <span className="lp-intel-lede-mobile" style={{ display: "none" }}>
                  BunnyCal keeps Google and Microsoft calendars in sync, so your booking page stays accurate.
                </span>
              </p>
              <div className="lp-intel-chips" style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 26 }}>
                {CHIPS.map((chip) => (
                  <span
                    key={chip.label}
                    className="lp-intel-chip"
                    style={{ fontSize: 13.5, padding: "8px 15px", borderRadius: "var(--lp-radius-pill)", background: "rgba(255,253,250,.07)", border: "1px solid rgba(255,253,250,.14)", color: "var(--lp-cream)" }}
                  >
                    <span className="lp-intel-chip-desktop">{chip.label}</span>
                    <span className="lp-intel-chip-mobile" style={{ display: "none" }}>
                      {chip.mobileLabel}
                    </span>
                  </span>
                ))}
              </div>
            </div>

            <div className="lp-intel-tracks" data-reveal-group style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {TRACKS.map((track, ti) => (
                <div className="lp-intel-track" key={track.name} style={{ display: "flex", alignItems: "center", gap: 12, marginTop: ti === TRACKS.length - 1 ? 8 : 0 }}>
                  <span className="lp-intel-track-name" style={{ width: 130, fontFamily: "var(--lp-mono)", fontSize: 11, letterSpacing: ".06em", color: "rgba(255,253,250,.55)" }}>
                    {track.name}
                  </span>
                  <div className="lp-intel-track-bars" style={{ flex: 1, display: "flex", gap: 5 }}>
                    {track.segs.map((s, i) => (
                      <span
                        key={i}
                        data-reveal="growx"
                        style={{
                          flex: s.flex,
                          height: 16,
                          borderRadius: 5,
                          background:
                            s.on === false
                              ? "rgba(255,253,250,.1)"
                              : s.on === "faint"
                                ? "rgba(255,253,250,.08)"
                                : (s.on as string),
                          transformOrigin: "left",
                        }}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
